import { useQuery } from "@tanstack/react-query";

import useTokenAccess from "src/hooks/auth/useTokenAccess";
import { useClinicContext } from "src/contexts/clinic/ClinicProvider";

import { EmrHubInstallerDownloadLinkType } from "../types";
import { getEmrHubInstallerDownloadLink } from "../api";

const TEN_MINUTES = 10 * 60 * 1000;

export const useLatestEmrHubVersion = () => {
  const { getToken } = useTokenAccess();
  const { clinicInfo } = useClinicContext();
  const clinicId = clinicInfo?.id;

  return useQuery<EmrHubInstallerDownloadLinkType>({
    queryKey: ["emr-hub-latest-version", clinicId],
    queryFn: async () => {
      if (!clinicId) throw new Error();
      const token = await getToken();
      return getEmrHubInstallerDownloadLink(token, clinicId);
    },
    enabled: Boolean(clinicId),
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: TEN_MINUTES,
  });
};
